<script setup lang="ts">
import {STAFF_ROLE_OPTIONS} from "@helpers/ConstantHelper.js";
</script>
<template>
  <AppChipSelect v-bind="$attrs" :items="STAFF_ROLE_OPTIONS" item-title="title"/>
</template>

